export enum Roles {
  FIJASTH_PY_VENTAS = 'FIJASTH_PY_VENTAS',
  FIJASTH_PY_EXCEPCION = 'FIJASTH_PY_EXCEPCION',
  FIJASTH_PY_EMPLE = 'FIJASTH_PY_EMPLE',
  DTHSTH_PY_VENTAS = 'DTHSTH_PY_VENTAS',
  DTHSTH_PY_EXCEPCION = 'DTHSTH_PY_EXCEPCION',
}

export type UserRole = {
  name: Roles;
};
export interface User {
  userName: string;
  mailAddress: string;
  displayName: string;
  legajo: string;
  roles: UserRole[];
  debtAuthorized: boolean;
  lastActivityTime?: string;
}

export type LoginParams = {
  username: string;
  password: string;
};
